import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: '',
    fields: 'flex flex-col gap-6 pb-12',
    row: 'flex items-center justify-between',
    button: 'w-full',
    forgotPassword: 'heading-s-bold h-auto p-0 normal-case',
    loginBySMS: 'text-label-green heading-xs mt-4 flex h-6 items-center p-0',
    arrowIcon: 'ml-2'
  },
  variants: {
    color: {
      primary: 'text-black'
    }
  },
  defaultVariants: {
    color: 'primary'
  }
});
